import { render, staticRenderFns } from "./CorporationEdit.vue?vue&type=template&id=10e796f9"
import script from "./CorporationEdit.vue?vue&type=script&lang=js"
export * from "./CorporationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports